<breadcrumb endText="Course List" [navigations]="breadcrumbNavs" />
<div class="m-5">
  <div class="flex justify-between">
    <div class="font-medium text-xl">
      Course List
    </div>
    <clear-button (click)="courseConfig()" [faIcon]="faPlus" text="Create new Course" />
  </div>
  <hr />
  @for (item of items; track item; let i = $index) {
    <div [ngClass]="i % 2 === 0? 'flex justify-between mt-2 p-2 rounded-[8px]': 'flex justify-between mt-2 p-2 rounded-[8px] bg-gray-100'">
      {{item.name}}
      <div class="mr-3">
        <dropdown-menu [menuItems]="item.items" aria-label="Course Menu"/>
      </div>
    </div>
  }
  <per-page-pagination
    [(currentPagination)]="currentPagination"
    perPageText="Courses"
    (perPageFunction)="handleServiceCall()"
    (decrementPageFunction)="handleServiceCall()"
    (incrementPageFunction)="handleServiceCall()"
    />
  </div>
